<template>
<div class="block-img" :class="{empty: !media}">
  <div class="img-empty" v-if="!post">
    (not selected)
  </div>
  <div class="img-selected" v-else>
    <a :href="url" target="_blank"><img v-if="thumbnail" :src="thumbnail" alt="" :class="{video: oembed}" /></a>
    <div>
      <label>Title:</label> <span><strong>{{ post.title }}</strong></span><br />
      <label>Url:</label> <span><a :href="url" target="_blank">{{ url }}</a></span><br />
      <button class="btn btn-large" v-on:click.prevent="$emit('input', 0)">Remove</button>
    </div>
  </div>
  <button class="btn btn-large" v-if="!media" v-on:click.prevent="select">Select</button>
</div>
</template>

<script>
import api from '@/Util/api';
export default {
  props: ["modelValue"],
  data: ()=>({
    post: null,
    media: null,
  }),
  watch: {
    modelValue: {
      immediate: true,
      async handler() {
        if (this.modelValue*1) {
          var data=await api.get("Post", this.modelValue);
          this.post=data.item;
        } else
          this.post=null;
      },
    },
    post: {
      immediate: true,
      async handler() {
        if (this.post && this.post.mainMedia) {
          this.media=(await api.get("Media", this.post.mainMedia)).item;
        } else
          this.media=null;
      }
    }
  },
  computed: {
    thumbnail() {
      var url=this.media && this.media.thumbnail;
      if (this.media && this.media.store && this.media.store.rootUrl)
        url=this.media.store.rootUrl+this.media.path;
      return url;
    },
    url() {
      if (this.post)
        return window.appData.absRoot+this.post.url+"/"
      return "";
    },
  },
  methods: {
    select() {
      postPopup.show("one", (itemId)=>{
        this.$emit("update:modelValue", itemId);
      });
    },
    formatFileType(path) {
      console.log(path);
      var res=path && path.match(/\.([^.\/]+)$/);
      return res?res[1]:"unknown";
    },
    formatFileSize(size) {
      size*=1;
      if (!size)
        return "(unknown)";
      if (size<1024)
        return size+" B";
      size/=1024;
      if (size<1024)
        return size.toFixed(2)+" kB";
      size/=1024;
      if (size<1024)
        return size.toFixed(2)+" MB";
      size/=1024;
      return size.toFixed(2)+" GB";
    },
  },
}
</script>
